module.exports = __webpack_public_path__ + "img/icon-user-circle.04ce3cd7.svg";